module.exports = __webpack_public_path__ + "static/media/down-icon.b042174a.svg";